module.exports = __webpack_public_path__ + "static/media/choice_hover.e48feea9.mp3";